import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Input from '../form-components/input/Input';
import Button from '../form-components/input/Button';
import { toast } from 'react-toastify';

const ChangeEmail: React.FC = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('')
    const [status, setStatus] = useState('idle');
    const [ error, setError ] = useState('')
    const navigate = useNavigate();

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setStatus('loading');
        const token = sessionStorage.getItem('token');

        try {
            const response = await fetch('https://backend-kyw8.onrender.com/change-email', {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                body: JSON.stringify({ email, password }),
            });
            console.log(token)
            const data = await response.json();

            if (response.status === 400) {
                setError(data.message)
                console.log(data);
            } else if (response.status === 201) {
                toast.error('Please verify your Email', {
                    position: 'bottom-right',
                });
                navigate('/confirm-email-change', {
                    state: { email },
                });
            } else {
                toast.error('An unexpected error occurred. Please try again later.', {
                    position: 'bottom-right',
                });
                console.log(data)
            }
        } catch (error) {
            console.error('Error:', error);
            toast.error('An unexpected error occurred. Please try again later.', {
                position: 'bottom-right',
            });
        } finally {
            setStatus('idle');
        }
    };

    return (
        <div className="mt-20 flex justify-center items-center">
            <div className="lg:border w-2/4 rounded-lg mt-20 lg:shadow-lg lg:bg-gray-100 lg:bg-opacity-80 p-8">
                <p className="text-xl font-semibold text-center mb-4">Change Email</p>
                <form onSubmit={handleSubmit}>
                    <div className="flex flex-col gap-10">
                        <Input
                            label="New Email"
                            onChange={(e) => setEmail(e.target.value)}
                            type="email"
                            value={email}
                            required
                        />
                        <Input
                            label="New Email"
                            onChange={(e) => setPassword(e.target.value)}
                            type="password"
                            value={password}
                            required
                        />
                    </div>
                    {error && <p className="text-red-500">{error}</p>}
                    <Button
                        buttonText="Change Email"
                        isLoading={status === 'loading'}
                        type="submit"
                    />
                </form>
            </div>
        </div>
    );
};

export default ChangeEmail;
